import { OnboardingStep } from 'types/onboardingTypes'

export function getExperienceInfo(): OnboardingStep {
  return {
    id: 'experience_info',
    type: 'custom',
  }
}
